import {Grid, Typography} from "@material-ui/core";
import {formatDate, formatDateObj, formatToCurrency} from "../../Formatter";
import {OrderHistoryDabStatusIndicator} from "../../OrderHistoryDabStatusIndicator";
import Label from "../../Label";
import SendRefundPositionModal from "../SendRefundPositionModal";
import React, {useEffect, useState} from "react";
import Order, {OrderPosition} from "../../../store/models/Order";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {DabDigitalOrder} from "../../../store/models/DabDigitalOrder";
import Api from "../../../store/Api";
import Contact from "../../../store/models/Contact";
import {RefundRequest} from "../../../store/models/RefundRequest";
import {
    ContactOrderDigitalPositionStatusIndicator,
    ContactOrderPositionStatusIndicator,
} from '../ContactOrderPositionStatusIndicator';

const useStyles = makeStyles((theme) => {
    return ({
        innerAccordion: {
            padding: theme.spacing(3)
        },
    });
});


function fetchTotalNettoValue(position: OrderPosition, allPositions: OrderPosition[]) {
    const subPositions = allPositions.filter(pos => pos.hauptPosNr === position.posNummer)
    if (subPositions.length > 0) {
        return subPositions.reduce((sum, pos) => sum + +pos.posNettowert, 0)
    } else {
        return position.posNettowert
    }
}

export function OrderHistoryPositions({
                                          order,
                                          contact,
                                          refundedOrderPositions,
                                          updateOrderPositions
                                      }: {
    order: Order,
    contact: Contact,
    refundedOrderPositions: RefundRequest[],
    updateOrderPositions: () => void
}) {
    const classes = useStyles();
    const {t} = useTranslation();
    const [digitalOrderStatusList, setDigitalOrderStatusList] = useState<DabDigitalOrder[]>([]);
    const fetchDigitalOrderStatusFromDab = () => {
        Api.getDigitalOrderStatusFromDabForCustomer(contact.sapCustomerID || '').then(data => {
            setDigitalOrderStatusList(data)
        })
    }
    useEffect(fetchDigitalOrderStatusFromDab, [contact.sapCustomerID])

    function getLabelAndValueIfDefinied(value: string, labelKey: string, withNewLine?: boolean) {
        if (value) {
            return <>
                {t('orderDetailsView.' + labelKey)}<span>{value}</span>
                {withNewLine ? <br/> : null}
            </>
        } else {
            return null;
        }
    }

    const condensedOrderPositions = order.positions.filter(position => !position.hauptPosNr)
    return <> <Grid item xs={12} style={{marginTop: 25}}><Typography
        variant={"h5"}>{t("contactDetailOrderHistoryTab.orderPositions")}</Typography></Grid>
        {condensedOrderPositions.map((position, indexPosition) => {

            const refundedPositions = refundedOrderPositions.filter(rP => rP.positionID === position.posNummer);


            return <Grid key={order.bestellNummer + 'postion' + indexPosition}
                         className={classes.innerAccordion} item xs={12}>
                <Grid container spacing={3} justifyContent={"space-around"}>
                    <Grid md={1}
                          item><Typography>{position.menge} {position.mengenEinheit}</Typography></Grid>
                    <Grid md={4}
                          item>
                        {position.materialBezeichnung}
                        <br/>
                        {position.materialNummer} / {position.artikelFarbe}
                        <br/>
                        {formatToCurrency(position.artikelpreisStueck, order.waehrung)}
                        <br/>
                        {position.fashionGroessen && position.fashionGroessen.length ?
                            getLabelAndValueIfDefinied(position.fashionGroessen.join(', '), "fashionGroessen", true)
                            : null
                        }
                        {position.konfiguration.map((konf, index) => (
                            <Typography
                                key={'key:' + position.posNummer + konf.keyTextcode + konf.textcode + index}
                                variant="body2">
                                {getLabelAndValueIfDefinied(konf.textcode, "konfTextcode", true)}
                                {getLabelAndValueIfDefinied(konf.nameWF, "konfNameWF", true)}
                                {konf.veredelung && konf.anzahlFarben ? <>
                                    {getLabelAndValueIfDefinied(konf.veredelung, "konfVeredelung")}&nbsp;-&nbsp;
                                    {getLabelAndValueIfDefinied(konf.anzahlFarben, "konfAnzahlFarben", true)}
                                </> : null}
                                {konf.drkfarben && konf.drkfarben.length && konf.sonderfarben && konf.sonderfarben ? <>
                                    {getLabelAndValueIfDefinied(konf.drkfarben.join(', '), "konfDRKFarben")}&nbsp;-&nbsp;
                                    {getLabelAndValueIfDefinied(konf.sonderfarben.join(', '), "konfSonderfarben", true)}
                                </> : null}

                            </Typography>
                        ))}


                    </Grid>
                    <Grid md={2}
                          item><Typography>{formatToCurrency(fetchTotalNettoValue(position, order.positions), order.waehrung)}</Typography></Grid>
                    <Grid md={3}
                          item>
                        {digitalOrderStatusList.find((entry) => entry.orderId === order.auftragsNummer && entry.posNummer === position.posNummer) ?
                            <OrderHistoryDabStatusIndicator position={position}
                                                            digitalOrderStatusList={digitalOrderStatusList}
                                                            orderId={order.auftragsNummer}/>
                            :
                            <>
                                <Typography>{position.linie?.toUpperCase() === "DIG" ||  ! position.auftragsStatus ? <ContactOrderDigitalPositionStatusIndicator
                                    status={position.gesamtStatusPos}
                                    cancellationReason={position.absagegrund}/> : <ContactOrderPositionStatusIndicator
                                    status={position.auftragsStatus}
                                    cancellationReason={position.absagegrund}/>}</Typography>

                                {position.wunschlieferDatum ? getLabelAndValueIfDefinied(formatDateObj(position.wunschlieferDatum), 'wunschlieferDatum', true) : null}
                                {position.WarenausgangIST ? getLabelAndValueIfDefinied(formatDateObj(position.WarenausgangIST), 'WarenausgangIST', true) : null}
                                {position.groessenSetSendedatum ? getLabelAndValueIfDefinied(formatDate(position.groessenSetSendedatum), 'groessenSetSendedatum', true) : null}

                                {position.absagegrund ? <>
                                    {position.absagegrund} - {position.absagegrundBezeichnung}
                                    <br/>
                                </> : null}
                                {position.EKSSperrdatum && position.EKSSperrgrund ?
                                    <>
                                        <br/>
                                        <Label
                                            color="error">{formatDate(position.EKSSperrdatum)} - {t('eksSperrgrund.' + position.EKSSperrgrund)}</Label>
                                    </>
                                    : null}
                            </>}
                    </Grid>
                    <Grid md={2}
                          item><SendRefundPositionModal order={order}
                                                        customerName={contact.companyLine1}
                                                        updateOrderPositions={updateOrderPositions}
                                                        position={position}/></Grid>
                </Grid>
                {
                    refundedPositions.length ?
                        <Grid item xs={12} container>
                            {refundedPositions.map(rP => <>
                                <Grid item xs={12}>
                                    <Typography
                                        variant={"h5"}
                                        color={"error"}>{t("orderHistoryPositions.refundOrderHeadline")}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{t("orderHistoryPositions.refundedByName")}{rP.refundedByName}</Typography>
                                    <Typography>{t("orderHistoryPositions.date")}{formatDate(rP.createdAt!)}</Typography>
                                    <Typography
                                        style={{whiteSpace: "pre-wrap"}}>{t("orderHistoryPositions.description")}{rP.description}</Typography>
                                    {rP.uploadedAttachments && rP.uploadedAttachments.length ?
                                        rP.uploadedAttachments.map(f=>
                                                // @ts-ignore
                                    <Typography>{f.originalname}</Typography>
                                        )
                                        : null}
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{t("orderHistoryPositions.contactType")}{t("RefundRequest.RefundRequestContactType." + rP.contactType)}</Typography>
                                    <Typography>{t("orderHistoryPositions.contactPersonName")}{rP.contactPersonName}</Typography>
                                    <Typography>{t("orderHistoryPositions.amount")}{rP.amount}</Typography>
                                    <Typography>{t("orderHistoryPositions.complaint")}{t("RefundRequest.Complaint." + rP.complaint)}</Typography>
                                    <Typography>{t("orderHistoryPositions.whereabouts")}{t("RefundRequest.Whereabouts." + rP.whereabouts)}</Typography>
                                    <Typography>{t("orderHistoryPositions.proposedSolution")}{t("RefundRequest.ProposedSolution." + rP.proposedSolution)}</Typography>
                                </Grid>
                            </>)}

                        </Grid>
                        : null}
            </Grid>
        })}</>
}